/**
 * On-demand lightGallery entry point.
 *
 * Bundled by esbuild into Resources/Public/JavaScript/Dist/lightgallery.min.js
 * and included only by the templates that render a gallery (see
 * Media/{Collage,Gallery,Slider}.html and news/Layouts/Detail.html).
 *
 * lightGallery is exposed globally because main.js `initGallery()` and the
 * inline gallery scripts instantiate it via `window.lightGallery(...)`.
 */
import lightGallery from 'lightgallery'

window.lightGallery = lightGallery
